import { Link } from "react-router-dom";
import AccountLink from "./AccountLink";

const Footer = () => {
  return (
    <footer
      className="border-t border-[#EAE5DF] bg-card mt-20"
      data-testid="site-footer"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-10 pt-14 pb-12 lg:pb-16 overflow-hidden">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="min-w-0">
            <h4 className="label-uppercase mb-4">Company</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="hover:underline" data-testid="footer-about-link">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:underline" data-testid="footer-contact-link">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          <div className="min-w-0">
            <h4 className="label-uppercase mb-4">Policies</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/terms" className="hover:underline" data-testid="footer-terms-link">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:underline" data-testid="footer-privacy-link">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
          <div className="min-w-0">
            <h4 className="label-uppercase mb-4">Customer</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/refund-policy" className="hover:underline" data-testid="footer-refund-link">
                  Refund &amp; Cancellation
                </Link>
              </li>
              <li>
                <Link to="/shipping-policy" className="hover:underline" data-testid="footer-shipping-link">
                  Shipping Policy
                </Link>
              </li>
              <li>
                <AccountLink testIdPrefix="footer" className="!text-[#1A1A1A] hover:underline" />
              </li>
            </ul>
          </div>
          <div className="col-span-2 md:col-span-1 min-w-0">
            <h4 className="label-uppercase mb-4">Contact</h4>
            <ul className="space-y-2 text-sm text-[#6B6B6B]">
              <li className="break-all">
                <a
                  href="mailto:contact@thesnuggleprints.com"
                  className="hover:underline"
                  data-testid="footer-email-link"
                >
                  contact@thesnuggleprints.com
                </a>
              </li>
              <li>Mon to Sat, 10:00 to 19:00 IST</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-[#EAE5DF] pt-6 pb-4 flex flex-col sm:flex-row justify-between gap-4 text-xs text-[#6B6B6B]">
          <div>
            © {new Date().getFullYear()} The Happy Prints Company (theSnugglePrints). All rights reserved.
            <span className="ml-2 opacity-70">Udyam: UDYAM-KR-03-0766778</span>
          </div>
          <div>Handcrafted in India. Secure payments via Razorpay.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
